module.exports = __webpack_public_path__ + "img/124.4.4a7509cd.png";